import { ApolloProvider } from '@apollo/client'
import { Dispatch, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { UserInfoDocument } from 'src/graphql/generated/hooks'
import { useApolloClient } from 'src/hooks/useApolloClient'
import { setProfile } from 'src/store/actions/auth'

interface Props {
  token?: string
  children: React.ReactElement
}

export const ComponentWrapper: React.FC<Props> = ({ token, children }) => {
  const apolloClient = useApolloClient()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch: Dispatch<any> = useDispatch()

  const getUserInfo = async () => {
    const res = await apolloClient.query({
      query: UserInfoDocument,
      variables: { token },
    })
    const userInfo = res?.data?.userInfo
    if (userInfo) {
      const setProfileData = setProfile({
        name: userInfo?.username,
        id: userInfo?.external_id || '',
        companyName: userInfo?.companyName || '',
        companyType: userInfo?.companyType || '',
        isPremium: userInfo?.isPremium || false,
        isVendor: userInfo?.isVendor || false,
        hasVendorCentralAccess: userInfo?.hasVendorCentralAccess || false,
        vendor: userInfo?.vendor?.name || '',
        publishedAt: userInfo?.vendor?.publishedAt || null,
        premiumOrganizationId: userInfo?.premiumOrganization?.documentId || null,
        premiumOrganizationName: userInfo?.premiumOrganization?.name || null,
      })
      dispatch(setProfileData)
    }
  }

  useEffect(() => {
    if (token) {
      getUserInfo()
    }
  }, [token])

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
}
